import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { PlatformReferrals } from '../types/domain';

export function platformReferralsEndpoints(http: HttpClient) {
  return {
    get: () => http.get<ApiEnvelope<PlatformReferrals>>('/v1/platform/referrals').then(unwrap),
  };
}
export type PlatformReferralsEndpoints = ReturnType<typeof platformReferralsEndpoints>;
